import React from "react";

export default function Projekte() {
  return (
    <section className="bg-dark text-white min-h-screen p-6 md:p-12">
      <h2 className="text-3xl font-bold text-gold mb-6 text-center">Projekte</h2>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Projekt 14: Masterarbeit – Data Science und maschinelles Lernen auf Basis realer historischer Verkehrsdaten */}
        <div className="bg-gradient-to-br from-gold/20 to-gray-800 border border-gold p-6 rounded-2xl shadow-2xl">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Masterarbeit – Data Science und maschinelles Lernen auf Basis realer historischer Verkehrsdaten (2026)
          </h4>
          <p className="text-sm mb-2">
            Die Masterarbeit umfasst eine komplette Analyse von historischen Verkehrsdaten der Stadt Herne (Jahre 2022-2024). Dabei wurde eine Pipeline entwickelt, die mit einer explorativen Datenanalyse startet und die Daten deskriptiv, zeitlich und räumlich analysiert. Der zweite Schritt war eine Validierung mit Referenzdaten (Induktionsschleifen), wo der Hauptkern bei der Auswertung der Datenqualität der FCD lag. Durch Feature Engineering Methodiken wurden wichtige Merkmale zur Erstellung von Prgonosen erstellt. Der letzte Schritt war dann die Erstellung von Verkehrsprognosen und Forecasts mithilfe von KI-Methoden.
          </p>
          <p className="text-sm">
            <strong>Technologien & Methoden:</strong> Python, Jupyter Notebook, VS-Code, Pandas, NumPy, scikit-learn, Streamlit, matplotlib, Big‑Data‑Pipeline/ETL, Time‑Series‑Forecasting, Random‑Forest, Baselines, Regression, XGBoost, RMSE, MAE, GeoJSON, WKT/WKB, EPSG, CRS Transformation, Nearest Neighbor Matching
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Masterarbeit_Kelez_Informationstechnik.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Vollständige Thesis als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 12: Bachelorarbeit – CCD-Spektrometer zur Farbanalyse (2022) */}
        <div className="bg-gradient-to-br from-gold/20 to-gray-800 border border-gold p-6 rounded-2xl shadow-2xl">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Bachelorarbeit: CCD-Spektrometer zur Farbanalyse im sichtbaren Spektrum (2022)
          </h4>
          <p className="text-sm mb-2">
            In dieser Bachelorarbeit wurde ein eigenes CCD-basiertes Spektrometer entwickelt, programmiert und getestet. Der Fokus lag auf der Kalibrierung, Messung und Auswertung von Absorptionsspektren im sichtbaren Bereich (405–751 nm). Es wurden eigene Algorithmen in Arduino und MATLAB umgesetzt, zahlreiche Substanzen (Blut, Chlorophyll, Tinte) untersucht und die Qualitätsparameter des Spektrometers bewertet.
          </p>
          <p className="text-sm">
            <strong>Technologien & Methoden:</strong> UV/Vis-Spektroskopie, Arduino (TSL1401), MATLAB, CCD-Sensor, Extinktionsmessung, Absorptionsspektren, Farbmessung, Eigenbau-Hardware, Kalibrierung mit Laserpointern
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Bachelorarbeit.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Vollständige Thesis als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 13: implantierbare Antennen / SAR-Analyse */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Entwicklung, Modifikation und Simulation einer implantierbaren Patch-Antenne im ISM-Band
          </h4>
          <p className="text-sm mb-2">
            Miniaturisierte und biokompatible 2,4 GHz-Antenne für medizinische Implantate. Entwicklung, Modifikation, Simulation (Keysight EMPro), HF-Analyse (S11, VSWR, Gain) und SAR-Bewertung unter realitätsnahen Bedingungen.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> EMPro (FEM/FDTD), MATLAB, SAR-Modellierung, medizinische Simulation, Slot-Modifikationen, Hochfrequenztechnik, Implantate, Signalanalyse
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Masterstudienarbeit.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht zur Masterstudienarbeit als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 6: Biosignalverarbeitung (Hausarbeit) */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Biosignalverarbeitung mit MATLAB – EEG & Herzrate (2023)
          </h4>
          <p className="text-xs italic text-gray-400 mt-1">
            Hinweis: Diese Hausarbeit entstand im Rahmen einer Modulprüfung. Inhalte wurden vollständig selbstständig erstellt und zur Veröffentlichung anonymisiert.
          </p>
          <p className="text-sm mb-2">
            In dieser Hausarbeit wurden EEG-Signale analysiert, gefiltert und mit Kreuzkorrelation untersucht. Zusätzlich wurde eine lineare Approximation der Herzrate entwickelt und grafisch analysiert. Die Lösungen und Auswertungen wurden mit MATLAB durchgeführt und dokumentiert.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> MATLAB, FIR-Filter, Kreuzkorrelation, Signal-Mittelung, Lineare Regression, Visualisierung
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/ReadMe.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Aufgaben-Kontext als PDF ansehen
            </a>
            <a
              href="/projekte/BSP_Aufgabe1_code.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              MATLAB-Code & Plots zu Aufgabe 1 ansehen
            </a>
            <a
              href="/projekte/BSP_Aufgabe2_code.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              MATLAB-Code & Plots zu Aufgabe 2 ansehen
            </a>
          </div>
        </div>

        {/* Projekt 1: MRT / SAR-Analyse */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Patienten-Sicherheit in der MRT: SAR-Analyse eines Implantats (2024)
          </h4>
          <p className="text-sm mb-2">
            In dieser Projektarbeit wurde die spezifische Absorptionsrate (SAR) eines implantierten Stents im MRT simuliert
            und ausgewertet. Ziel war die Analyse thermischer Risiken und die Bewertung elektromagnetischer Felder mithilfe
            realitätsnaher Birdcage-Spulen.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> EMPro (FEM/FDTD), MATLAB, SAR-Modellierung, medizinische Simulation
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Projektarbeit1_Master.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 2: 5G-Antennendesign */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Design & Simulation moderner Antennenstrukturen für 5G (2024)
          </h4>
          <p className="text-sm mb-2">
            Diese Projektarbeit untersucht die Leistungsparameter moderner 5G-Antennenkonzepte mittels EMPro-Simulationen.
            Im Fokus standen Mikrostrip-Patch-Antennen sowie Multiband-MIMO-Designs mit praktischen Simulationsergebnissen.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> EMPro, MATLAB, FDTD/FEM, Patch-Design, MIMO, 5G-Millimeterwellenanalyse
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Projektarbeit2_Master.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 3: HSI-Klassifikation (KI1) */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Klassifikation hyperspektraler Daten mit ML (KI-Systeme 1 – 2024)
          </h4>
          <p className="text-sm mb-2">
            Diese Projektarbeit behandelt die Klassifikation von Hyperspektraldaten des Indian-Pines-Datensatzes mithilfe von PCA und SVM. Ziel war die effektive Reduktion hochdimensionaler Daten sowie die zuverlässige Klassifikation mit Machine-Learning-Methoden.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> Python, PCA, Scikit-Learn, SVM, Hyperspectral Imaging, Indian Pines
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/KIS1_Projektarbeit.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht als PDF ansehen
            </a>
            <a
              href="https://github.com/BKelez/hyperspectral-classification"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              GitHub-Projekt ansehen
            </a>
          </div>
        </div>

        {/* Projekt 4: CIFAR-Image Classification (KI2) */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Deep Learning Klassifikation von CIFAR10/100 (KI-Systeme 2 – 2024)
          </h4>
          <p className="text-sm mb-2">
            Diese Arbeit untersucht die Bildklassifikation mithilfe von CNNs und Transfer Learning. Es wurde die Leistung auf CIFAR10 und CIFAR100 verglichen und Methoden wie EarlyStopping und Datenaugmentation eingesetzt.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> Python, TensorFlow, Keras, CNN, Transfer Learning, MobileNetV2, VGG, EfficientNet
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/KIS2_Projektarbeit.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht als PDF ansehen
            </a>
            <a
              href="https://github.com/BKelez/Image-Classification-of-CIFAR10-and-CIFAR100-datasets"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              GitHub-Projekt ansehen
            </a>
          </div>
        </div>

        {/* Projekt 5: Roboscan – Projektmanagement und Projektplanung */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Projektmanagement und Projektplanung (Gruppenprojekt 2024)
          </h4>
          <p className="text-sm mb-2">
            Dieses Projekt entstand in Teamarbeit und behandelt die Konzeption eines intelligenten Kassensystems auf Basis eines mobilen Roboters. Ziel war die vollständige Planung inkl. Projektstrukturplan, MVP, Budget, Risikoanalyse und Zeitplanung.
            Die Präsentation wurde in klar verteilten Verantwortlichkeiten erstellt und enthält markiert, wer welche Teile bearbeitet hat.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> Projektmanagement, Stakeholder-Analyse, Business Case, PowerPoint, GANTT, Value Proposition
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Roboscan_Praesentation.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Präsentation (Gruppenarbeit) ansehen
            </a>
            <a
              href="/projekte/Roboscan_Eigenanteil.zip"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Mein Eigenanteil als zip-Datei runterladen
            </a>
          </div>
        </div>

        {/* Projekt 7: Verilog Embedded Projects */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Verilog HDL – Digitale Logikmodule (Embedded Systems, 2024)
          </h4>
          <p className="text-sm mb-2">
            Sammlung grundlegender Verilog-Module aus dem Modul Embedded Systems, darunter ALU, FIFO, Pipelining, Traffic Controller, Decoder, Multiplexer, Priority Encoder, XOR und Minority Logic. Jedes Modul ist funktionsfähig, testbar und simuliert mit Icarus Verilog und GTKWave.
          </p>
          <p className="text-sm">
            <strong>Technologien:</strong> SystemVerilog, RTL-Design, FSM, Synthese, Simulation mit Icarus Verilog & GTKWave, VS Code
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="https://github.com/BKelez/Verilog-Embedded-Projects"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              GitHub-Projekt ansehen
            </a>
          </div>
        </div>
        {/* Projekt 9: Obstruktive Schlafapnoe – Diagnose & Therapie */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Diagnose und Therapie der obstruktiven Schlafapnoe (2021)
          </h4>
          <p className="text-sm mb-2">
            Diese wissenschaftliche Arbeit beleuchtet die physiologischen, diagnostischen und therapeutischen Aspekte der obstruktiven Schlafapnoe (OSA). Sie bietet eine fundierte Analyse aktueller Verfahren wie Polysomnographie, CPAP-Therapie, sowie innovativer Behandlungsansätze wie die hypoglossale Nervenstimulation. Kritisch reflektiert werden auch Studienaufbau, Reproduzierbarkeit und moderne Diagnostikmethoden.
          </p>
          <p className="text-sm">
            <strong>Technologien & Themen:</strong> Polysomnographie, CPAP, Hypoglossale Nervenstimulation, Schlafmedizin, Biomarker, klinische Studien, OSA-Therapie, medizinische Innovation
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/obstruktive_Schlafapnoe.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektarbeit als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 11: Polysomnographie – Schlafdiagnostik & Analyseverfahren */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Polysomnographie – Schlafdiagnostik & Analyseverfahren (2021)
          </h4>
          <p className="text-sm mb-2">
            Diese Präsentation behandelt umfassend die Grundlagen und technischen Aspekte der Polysomnographie – dem Goldstandard in der Diagnostik von Schlafstörungen. Es werden Schlafstadien, Signalableitung (EEG, EOG, EMG), Geräteanforderungen, Filtermethoden sowie wirtschaftliche Rahmenbedingungen beleuchtet. Außerdem werden Alternativen wie die Polygraphie diskutiert.
            Diese Arbeit ist ein Teil einer Teamarbeit, welches aus drei Teilen bestand. Die Erstellung einer Präsentation, eines Plakats und eines Artikels. Die Präsentation wurde von mir persönlich erstellt. 
          </p>
          <p className="text-sm">
            <strong>Technologien & Themen:</strong> Polysomnographie, Biosignalverarbeitung, Filtertechniken, Hypnogramm, EOG/EMG/EEG, Schlafphasen, Medizintechnik, Diagnostikgeräte
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Polysomnographie_Praesentation.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Präsentation als PDF ansehen
            </a>
          </div>
        </div>

         {/* Projekt 8: Schlafanalyse mit Consumer-Technologie */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Schlafanalyse mit Consumerelektronik & ethischer Bewertung (2020)
          </h4>
          <p className="text-sm mb-2">
            In dieser wissenschaftlichen Projektarbeit werden Polysomnographie, Schlafphasen, Tracker-Technologien und Wearables analysiert und kritisch verglichen. Die Arbeit beleuchtet die Chancen und Risiken aktueller Schlaftracking-Apps im Hinblick auf Genauigkeit, Datenschutz und ethische Verantwortung.
          </p>
          <p className="text-sm">
            <strong>Technologien & Themen:</strong> Schlafmedizin, Polysomnographie, Wearables, Schlaf-Apps, Signalverarbeitung, Datenschutz, Ethik, Zukunftsvisionen
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/Projektarbeit_Schlafanalyse.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektarbeit als PDF ansehen
            </a>
          </div>
        </div>
        {/* Projekt 10: MCI – Interaktive Körperwaage & Gesundheitsapp */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Mensch-Computer-Interaktion: Prototyping und Schnittstellenkonstruktion (2021)
          </h4>
          <p className="text-sm mb-2">
            Diese Projektarbeit im Rahmen eines Mensch-Computer-Interaktion-Kurses dokumentiert die nutzerzentrierte Entwicklung eines Konzepts für eine intelligente Körperwaage mit App. Der Fokus lag auf Umfrageauswertung, Personas, Anwendungszenarien, Papierprototypen und einem Usability-Walkthrough. Die Ergebnisse wurden strukturiert evaluiert und in einem umfassenden Bericht dokumentiert.
          </p>
          <p className="text-sm">
            <strong>Technologien & Methoden:</strong> Human-Centered Design, Usability Walkthrough, Personas, Prototyping, Gesundheits-Tracking, Ernährung, Umfrageauswertung
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/MCI_Projektabschlussbericht.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Projektbericht als PDF ansehen
            </a>
          </div>
        </div>

        {/* Projekt 9: Lifelogging */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Lifelogging – Selbstvermessung, Kontrolle & Digitalisierung (2018)
          </h4>
          <p className="text-sm mb-2">
            Diese Präsentation beleuchtet die Chancen und Gefahren digitaler Selbstvermessung ("Lifelogging"). Diskutiert werden technische Möglichkeiten, ethische Herausforderungen und gesellschaftliche Entwicklungen – vom Fitness-Tracker bis zur rationalen Diskriminierung.
          </p>
          <p className="text-sm">
            <strong>Technologien & Themen:</strong> Digitale Ethik, Selbstvermessung, Algorithmische Kontrolle, Überwachung, Datenwirtschaft
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <a
              href="/projekte/LifeLogging.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gold underline hover:text-white transition"
            >
              Präsentation als PDF ansehen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
